
// Load on view
jQuery(window).on('scroll', function() {
  jQuery('.stats-wrapper:not(.in-view)').each(function() {
      if (isInView(jQuery(this))) {
          console.log('Element is in view!');
          jQuery(this).addClass('in-view'); // Ensure it only triggers once

          // This is the number counter
          jQuery('.stats-wrapper .count').each(function () {
            const $this = jQuery(this);
            const originalText = $this.text().trim();
            
            // Detect if original uses comma as thousands separator
            const hasComma = originalText.includes(',');
            
            // Remove commas and spaces for parsing
            const cleanNumber = originalText.replace(/[,\s]/g, '');
            
            // Check if it's a valid number
            if (!isNaN(cleanNumber) && cleanNumber !== '') {
              const targetNumber = parseFloat(cleanNumber);
              
              $this.prop('Counter', 0).animate({
                Counter: targetNumber
              }, {
                duration: 4000,
                easing: 'swing',
                step: function (now) {
                  // Use Math.floor to avoid rounding up during animation
                  const rounded = Math.floor(now);
                  // Format with commas if original had them
                  const formatted = hasComma 
                    ? rounded.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                    : rounded.toString();
                  $this.text(formatted);
                },
                complete: function() {
                  // Restore exact original text at the end
                  $this.text(originalText);
                }
              });
            }
          });
      }
  });
});


function isInView(element) {
  const windowTop = jQuery(window).scrollTop();
  const windowBottom = windowTop + jQuery(window).height();
  const elementTop = element.offset().top;
  const elementBottom = elementTop + element.height();

  return elementBottom > windowTop && elementTop < windowBottom;
}